export enum RaffleExtractionType {
  LOTTERY = 'LOTTERY',
  MANUAL = 'MANUAL',
  RANDOM = 'RANDOM',
  GIRO = 'GIRO',
}

export enum LuckySequencyType {
  SCRATCHER = 'SCRATCHER',
  INSTANT_PRIZE = 'INSTANT_PRIZE',
  LUCKY_WHEEL = 'LUCKY_WHEEL',
  SPINNING_TOP = 'SPINNING_TOP',
}
